import React from 'react'
import { Spin } from 'antd';
import { withRouter } from 'react-router-dom';
export default withRouter(() => {
 return(
   <>
    <Spin tip="Loading..." />
   </>
 )
})